/* eslint-disable no-console */

// Dependency-free service worker registration (no build plugin required).
// Only active in production builds; the dev server is left untouched.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
        const swUrl = `${process.env.BASE_URL}service-worker.js`

        navigator.serviceWorker
            .register(swUrl)
            .then((registration) => {
                console.log('Service worker registered:', registration.scope)

                registration.addEventListener('updatefound', () => {
                    const installing = registration.installing
                    if (!installing) return

                    installing.addEventListener('statechange', () => {
                        // A new build finished installing while an old worker is
                        // controlling the page. Wall displays run unattended, so
                        // reload to pick up the latest version automatically.
                        if (installing.state === 'installed' && navigator.serviceWorker.controller) {
                            console.log('New content available; reloading.')
                            window.location.reload()
                        }
                    })
                })
            })
            .catch((error) => {
                console.error('Service worker registration failed:', error)
            })
    })
}
